import { SchemaFormApi } from "@/components/form";

/*
  valores por defecto de un DE form
 */
export const DE_FORM_DEFAULTS = {
    tipoTransaccion: "1",
    condicionOperacion: "contado",
    tipoPago: "efectivo",
    tipoCredito: "plazo",
    plazoDias: "30",
    items: [],
} as const;

export const FACTURA_ELECTRONICA_DEFAULTS = {
    ...DE_FORM_DEFAULTS,
    indicadorPresencia: "1",
} as const;

export const AUTOFACTURA_DEFAULTS = {
    ...DE_FORM_DEFAULTS,
    tipoDocumentoAsociado: "3", // 3: constancia electronica; obligatorio en autofacturas
} as const;

export const NOTA_CREDITO_DEFAULTS = {
    ...DE_FORM_DEFAULTS,
    motivoEmision: "1",
    tipoDocumentoAsociado: "1",
} as const;

export const NOTA_REMISION_DEFAULTS = {
    ...DE_FORM_DEFAULTS,
    motivoEmisionNR: "1",
    responsableEmision: "1",
    kmRecorrido: 1,
    tipoDocumentoAsociado: "none",
    tipoTransporte: "1",
    modalidadTransporte: "1",
    responsableFlete: "1",
    fechaInicioTraslado: "",
    fechaFinTraslado: "",
    localSalida: { direccion: "", numeroCasa: 0, departamentoId: "", departamentoNombre: "", departamentoCodigo: "", ciudadId: "", ciudadNombre: "", ciudadCodigo: "" },
    localEntrega: { direccion: "", numeroCasa: 0, departamentoId: "", departamentoNombre: "", departamentoCodigo: "", ciudadId: "", ciudadNombre: "", ciudadCodigo: "" },
    vehiculo: { tipoVehiculo: "", marca: "", tipoIdentificacion: "2", numeroId: "", numeroMatricula: "" },
    transportista: { naturaleza: "1", nombre: "", ruc: "", dv: undefined, numeroDocChofer: "", nombreChofer: "" },
} as const;

/*
  Resetear DE form valores
 */
export function resetDEForm(
    formApi: SchemaFormApi<any>,
    defaults: Record<string, any>,
    preserveFields: string[] = []
) {
    // guardar valores de campos a preservar 
    const preservedValues: Record<string, any> = {};
    preserveFields.forEach(field => {
        preservedValues[field] = formApi.getFieldValue(field);
    });

    formApi.reset();

    // restaurar campos preservados
    Object.entries(preservedValues).forEach(([field, value]) => {
        formApi.setFieldValue(field, value);
    });

    // aplicar valores por defecto
    Object.entries(defaults).forEach(([field, value]) => {
        formApi.setFieldValue(field, value);
    });
}

/*
  Mensajes de exito para cada tipo de DE
 */
export const DE_SUCCESS_MESSAGES = {
    factura: "Se ha creado la factura electrónica correctamente.",
    autofactura: "Se ha creado la autofactura correctamente.",
    notaCredito: "Se ha creado la nota de crédito correctamente.",
    notaRemision: "Se ha creado la nota de remisión correctamente.",
} as const;

/*
  Titulos de confirmacion para cada tipo de DE
 */
export const DE_CONFIRM_TITLES = {
    factura: "Cancelar Factura Electrónica",
    autofactura: "Limpiar Autofactura",
    notaCredito: "Cancelar Nota de Crédito",
    notaRemision: "Cancelar Nota de Remisión",
} as const;

/*
  Descripciones de confirmacion para cada tipo de DE
 */
export const DE_CONFIRM_DESCRIPTIONS = {
    factura: "¿Estás seguro que quieres cancelar la factura electrónica actual?",
    autofactura: "¿Estás seguro que quieres limpiar la autofactura actual?",
    notaCredito: "¿Estás seguro que quieres cancelar la nota de crédito actual?",
    notaRemision: "¿Estás seguro que quieres cancelar la nota de remisión actual?",
} as const;
